import React from 'react';

type KeyCode = KeyboardEvent['code'];

export function useIsKeyPressed(targetKeyCode: KeyCode) {
  const [isKeyPressed, setIsKeyPressed] = React.useState(false);

  const downHandler = (event: KeyboardEvent) => {
    if (!event.metaKey && !event.ctrlKey && event.code === targetKeyCode) {
      setIsKeyPressed(true);
    }
  };

  const upHandler = (event: KeyboardEvent) => {
    if (!event.metaKey && !event.ctrlKey && event.code === targetKeyCode) {
      setIsKeyPressed(false);
    }
  };

  React.useLayoutEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);

    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isKeyPressed;
}
